import React from "react";
import Logo from "../../assests/images/vguard_logo.png";
import MenuIcon from "../../assests/images/menu.svg";
import "./topBar.css";

export const TopBar = ({ onClick }) => {
  return (
    <div className="navbar">
      <a href to="#" className="menu-bars">
        <button onClick={onClick}>
          <img src={MenuIcon} alt="Menu" />
        </button>
      </a>
      <img src={Logo} alt="Logo" width={120} className="img-logo" />
    </div>
  );
};
